import { tv } from 'tailwind-variants';

/**
 * Disclaimer component styles using design tokens
 */
const componentStyles = tv({
    slots: {
        base: `
    iris:font-(family-name:--comp-type-font-disclaimer)
    iris:text-(length:--comp-type-size-disclaimer)
    iris:font-(--comp-type-weight-disclaimer)!
    iris:tracking-(--comp-type-tracking-disclaimer)
  `,
        leading: "iris:leading-(--comp-type-leading-disclaimer)",
    },
    variants: {
        inverse: {
            true: {
                base: "iris:text-(--comp-color-content-type-disclaimer-inverse)",
            },
            false: {
                base: "iris:text-(--comp-color-content-type-disclaimer)",
            },
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { componentStyles as default };
